// Translations for the Members page (Members.js): member list, filters,
// member detail view, add/edit member modal, invite modal.
const membersDict = [
  { en: "Members", sw: "Wanachama" },
  { en: "total members", sw: "jumla ya wanachama" },
  { en: "Add Member", sw: "Ongeza Mwanachama" },
  { en: "Back to Members", sw: "Rudi kwa Wanachama" },
  { en: "Member #", sw: "Namba ya Mwanachama" },
  { en: "No employer", sw: "Hakuna mwajiri" },
  { en: "Joined", sw: "Alijiunga" },
  { en: "Edit Profile", sw: "Hariri Wasifu" },
  { en: "Send Invite", sw: "Tuma Mwaliko" },
  { en: "Contributions", sw: "Michango" },
  { en: "months", sw: "miezi" },
  { en: "Total Paid", sw: "Jumla Iliyolipwa" },
  { en: "Active Loans", sw: "Mikopo Inayoendelea" },
  { en: "Outstanding", sw: "Kiasi kinachodaiwa" },
  { en: "Personal", sw: "Kibinafsi" },
  { en: "Employment", sw: "Ajira" },
  { en: "Contact", sw: "Mawasiliano" },
  { en: "Personal Information", sw: "Taarifa ya Kibinafsi" },
  { en: "Full Name", sw: "Jina Kamili" },
  { en: "Email Address", sw: "Anwani ya Barua Pepe" },
  { en: "Phone Number", sw: "Namba ya Simu" },
  { en: "Gender", sw: "Jinsia" },
  { en: "Date of Birth", sw: "Tarehe ya Kuzaliwa" },
  { en: "National ID", sw: "Namba ya Kitambulisho" },
  { en: "Employment Information", sw: "Taarifa za Ajira" },
  { en: "Employer", sw: "Mwajiri" },
  { en: "Employment Number", sw: "Namba ya Ajira" },
  { en: "Department", sw: "Idara" },
  { en: "Job Title", sw: "Cheo cha Kazi" },
  { en: "Salary Range", sw: "Pembezo la Mshahara" },
  { en: "Membership Date", sw: "Tarehe ya Uanachama" },
  { en: "Contact Information", sw: "Taarifa za Mawasiliano" },
  { en: "Email", sw: "Barua pepe" },
  { en: "Not provided", sw: "Haijatolewa" },
  { en: "Phone", sw: "Simu" },
  { en: "Search members...", sw: "Tafuta wanachama..." },
  { en: "Search", sw: "Tafuta" },
  { en: "All", sw: "Zote" },
  { en: "Active", sw: "Inatumika" },
  { en: "Suspended", sw: "Amesimamishwa" },
  { en: "Retired", sw: "Amestaafu" },
  { en: "Loading members...", sw: "Inapakia wanachama..." },
  { en: "No Members Found", sw: "Hakuna Wanachama Waliopatikana" },
  { en: "Start by adding your first member to the system", sw: "Anza kwa kuongeza mwanachama wako wa kwanza kwenye mfumo" },
  { en: "Regular Member", sw: "Mwanachama wa Kawaida" },
  { en: "View", sw: "Angalia" },
  { en: "Edit", sw: "Hariri" },
  { en: "Delete", sw: "Futa" },
  { en: "Previous", sw: "Iliyotangulia" },
  { en: "Page", sw: "Ukurasa" },
  { en: "of", sw: "wa" },
  { en: "Next", sw: "Inayofuata" },
  { en: "Edit Member", sw: "Hariri Mwanachama" },
  { en: "New Member", sw: "Mwanachama Mpya" },
  { en: "First Name", sw: "Jina la Kwanza" },
  { en: "Middle Name", sw: "Jina la Kati" },
  { en: "Last Name", sw: "Jina la Mwisho" },
  { en: "Select", sw: "Chagua" },
  { en: "Male", sw: "Mwanaume" },
  { en: "Female", sw: "Mwanamke" },
  { en: "Other", sw: "Nyingine" },
  { en: "Profile Picture", sw: "Picha ya Wasifu" },
  { en: "Remove", sw: "Ondoa" },
  { en: "Change Picture", sw: "Badilisha Picha" },
  { en: "Upload Picture", sw: "Pakia Picha" },
  { en: "Employment #", sw: "Namba ya Ajira #" },
  { en: "Salary", sw: "Mshahara" },
  { en: "Branch", sw: "Tawi" },
  { en: "Select branch", sw: "Chagua tawi" },
  { en: "Membership Status", sw: "Hali ya Uanachama" },
  { en: "Pending profile completion", sw: "Inasubiri ukamilishaji wa wasifu" },
  { en: "Cancel", sw: "Ghairi" },
  { en: "Update Member", sw: "Sasisha Mwanachama" },
  { en: "Create Member", sw: "Unda Mwanachama" },
  { en: "Send Invitation", sw: "Tuma Mwaliko" },
  { en: "Send invitation to", sw: "Tuma mwaliko kwa" },
  { en: "Are you sure you want to delete this member?", sw: "Una uhakika unataka kufuta mwanachama huyu?" },
  { en: "Failed to send invite", sw: "Imeshindikana kutuma mwaliko" },
  { en: "no phone number", sw: "hakuna namba ya simu" },
  { en: "Invitation sent", sw: "Mwaliko umetumwa" },
  { en: "Invitation not delivered", sw: "Mwaliko haujafika" },
  { en: "Not sent", sw: "Haijatumwa" },
  { en: "Check the email address and phone number, then try again. Details are in SMS Logs and System Logs.", sw: "Hakiki barua pepe na namba ya simu, kisha jaribu tena. Maelezo yako kwenye SMS Logs na System Logs." },
  { en: "Invitation processed.", sw: "Mwaliko umechakatwa." },
  { en: "Activation link:", sw: "Kiungo cha kuwezesha:" },
  { en: "Email sent:", sw: "Barua pepe imetumwa:" },
  { en: "SMS sent:", sw: "SMS imetumwa:" },
  { en: "yes", sw: "ndiyo" },
  { en: "no", sw: "hapana" },
  { en: "Taarifa zimebadilishwa lakini picha haikuweza kupakia", sw: "Taarifa zimebadilishwa lakini picha haikuweza kupakia" },
  { en: "Details updated but the photo could not be uploaded", sw: "Taarifa zimebadilishwa lakini picha haikuweza kupakia" },
  { en: "Mwanajamii ameongezwa lakini picha haikuweza kupakia", sw: "Mwanajamii ameongezwa lakini picha haikuweza kupakia" },
  { en: "Member added but the photo could not be uploaded", sw: "Mwanajamii ameongezwa lakini picha haikuweza kupakia" },
  { en: "Hitilafu imetokea kupakia taarifa", sw: "Hitilafu imetokea kupakia taarifa" },
  { en: "An error occurred while saving the details", sw: "Hitilafu imetokea kupakia taarifa" },
];

export default membersDict;
